
export default {
  props: {
    title: {
      default: 'appointmentIsNotCreated',
    },
    description: {
      default: 'appointmentIsNotCreatedDescription',
    },
  },
}
